// Initialize next_best_products at the top
window.next_best_products = {};
let next_best_products_loaded = false;

// Load next_best_products data via GraphQL
(async () => {
  const SF_TOKEN = '3af85096f0acc2de26b757fa5d6c1a65';
  const GRAPHQL_URL = '/api/2025-04/graphql.json';

  const query = `{
    products(first: 250) {
      edges {
        node {
          handle
          id
          styleMF: metafield(namespace:"custom", key:"next_best_style") {
            references(first: 10) {
              edges {
                node {
                  ... on Product {
                    handle
                  }
                }
              }
            }
          }
          colourMF: metafield(namespace:"custom", key:"next_best_colour") {
            references(first: 10) {
              edges {
                node {
                  ... on Product {
                    handle
                  }
                }
              }
            }
          }
        }
      }
    }
  }`;

  try {
    const res = await fetch(GRAPHQL_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': SF_TOKEN,
      },
      body: JSON.stringify({ query }),
    });

    if (!res.ok) {
      console.error(`GraphQL request failed: ${res.status} ${res.statusText}`);
      return;
    }

    const json = await res.json();

    if (json.errors) {
      console.error('❌ GraphQL errors:', json.errors);
      return;
    }

    json.data.products.edges.forEach(({ node }) => {
      if (!node.handle) return;
      
      try {
        // Extract handles directly from the references
        const styleHandles = node.styleMF?.references?.edges?.map(edge => edge.node.handle) || [];
        const colourHandles = node.colourMF?.references?.edges?.map(edge => edge.node.handle) || [];

        if (styleHandles.length || colourHandles.length) {
          window.next_best_products[node.handle] = {};
          if (styleHandles.length) window.next_best_products[node.handle].next_best_style = styleHandles;
          if (colourHandles.length) window.next_best_products[node.handle].next_best_colour = colourHandles;
        }
      } catch (parseError) {
        console.error(`Error parsing metafields for ${node.handle}:`, parseError);
      }
    });
    
    // Set flag to true before dispatching event
    next_best_products_loaded = true;
    // Dispatch event when data is loaded
    document.dispatchEvent(new CustomEvent('next-best-products-loaded'));
  } catch (error) {
    console.error('Failed to load next best products:', error);
  }
})();

// js/common/cart/fetch-cart.js
const createCartPromise = async () => {
  return await (await fetch(`${Shopify.routes.root}cart.js`)).json();
};
let fetchCart = createCartPromise();

document.addEventListener('cart:change', (event) => {
  fetchCart = event.detail['cart'];
});
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    fetchCart = createCartPromise();
  }
});

// js/common/cart/next-best-products.js
const totalItems = 6;
async function updateHiddenFields(cart) {
  if (!cart || !cart.items) return;

  let colourHandles = [];
  let styleHandles = [];

  // Only check next_best_products if the data is loaded
  if (next_best_products_loaded) {
    // Collect product handles from cart items
    for (const item of cart.items) {
      const itemHandle = item.handle;

      if (!itemHandle) continue;

      // Get next best products from window.next_best_products variable
      if (window.next_best_products[itemHandle]) {
        const nextBestData = window.next_best_products[itemHandle];
        for (const key in nextBestData) {
          const metafieldItems = nextBestData[key];
          if (Array.isArray(metafieldItems)) {
            for (const metafieldItem of metafieldItems.slice(0, 10)) {
              if (metafieldItem) {
                // Add to colour or style lists based on key type
                if (key.includes('colour') && colourHandles.length < totalItems) {
                  colourHandles.push(metafieldItem);
                } else if (key.includes('style') && styleHandles.length < totalItems) {
                  styleHandles.push(metafieldItem);
                }

                if (colourHandles.length >= totalItems && styleHandles.length >= totalItems) break;
              }
            }
          }
          if (colourHandles.length >= totalItems && styleHandles.length >= totalItems) break;
        }
      }
      if (colourHandles.length >= totalItems && styleHandles.length >= totalItems) break;
    }
  }

  // Add extra products if needed to reach totalItems
  if (colourHandles.length < totalItems || styleHandles.length < totalItems) {
    const collectionHandle = 'most-popular-products';

    const response = await fetch(`/collections/${collectionHandle}/products.json`);

    if (!response.ok) {
      console.error(`Failed to fetch fallback products: ${response.status} ${response.statusText}`);
      return;
    }

    const data = await response.json();

    // Extract the handles of all items in the cart
    const cartHandles = cart.items.map((item) => item.handle);

    for (const extraProduct of data.products) {
      if (
        !colourHandles.includes(extraProduct.handle) &&
        !styleHandles.includes(extraProduct.handle) &&
        !cartHandles.includes(extraProduct.handle)
      ) {
        if (colourHandles.length < totalItems) {
          colourHandles.push(extraProduct.handle);
        } else if (styleHandles.length < totalItems) {
          styleHandles.push(extraProduct.handle);
        }

        if (colourHandles.length >= totalItems && styleHandles.length >= totalItems) break;
      }
    }
  }

  // Clean up arrays when they're no longer needed
  colourHandles = colourHandles.slice(0, totalItems);
  styleHandles = styleHandles.slice(0, totalItems);
  renderHiddenFields(colourHandles, styleHandles, cart);
  colourHandles = null; // Allow garbage collection
  styleHandles = null;
}

function renderHiddenFields(colourHandles, styleHandles, cart) {
  const container = document.querySelector('#hidden-fields-container');
  if (!container) {
    return;
  }
  container.innerHTML = '';

  // Render colour hidden fields
  colourHandles.forEach((handle, index) => {
    if (handle) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `attributes[next_best_colour_${index + 1}]`;
      input.value = handle;
      container.appendChild(input);
    }
  });

  // Render style hidden fields
  styleHandles.forEach((handle, index) => {
    if (handle) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `attributes[next_best_style_${index + 1}]`;
      input.value = handle;
      container.appendChild(input);
    }
  });

  // Add hidden fields for boot types in cart
  let itemCounter = 1;
  for (const item of cart.items) {
    const title = item.title ? item.title.toLowerCase() : '';
    if (!title) continue;

    // Check if the item title contains specific boot names but not 'bobbi kids'
    if (
      !title.includes('bobbi kids') && !title.includes('andie kids') &&
      (title.includes('bobbi') || title.includes('tully') || title.includes('fergie') || title.includes('andie') || title.includes('darcy') || title.includes('lochie') || title.includes('billie'))
    ) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `attributes[boot_${itemCounter}]`;
      input.value = item.handle;
      container.appendChild(input);

      itemCounter++;
    }
  }
}

// Initialize the cart right away without waiting for next_best_products
document.addEventListener('DOMContentLoaded', async () => {
  try {
    const cart = await fetchCart;
    await updateHiddenFields(cart);
  } catch (error) {
    console.error('Error updating hidden fields on page load:', error);
  }
});

// Initialize next_best_products storage
document.addEventListener('cart:change', async (event) => {
  try {
    await updateHiddenFields(event.detail['cart']);
  } catch (error) {
    console.error('Error updating hidden fields on cart change:', error);
  }
});

window.addEventListener('pageshow', async (event) => {
  if (event.persisted) {
    try {
      const cart = await fetchCart;
      await updateHiddenFields(cart);
    } catch (error) {
      console.error('Error updating hidden fields on page show:', error);
    }
  }
});

document.addEventListener('next-best-products-loaded', async () => {
  try {
    const cart = await fetchCart;
    await updateHiddenFields(cart);
  } catch (error) {
    console.error('Error updating hidden fields after products loaded:', error);
  }
});